import http from '@/http'
import Router from "@/router";
import {notifyError} from "@/components/composables/messages";
import { usePermissions } from '@/utils/permissions';

export const state = {
    currentUser: {},
}

export const mutations = {
    setCurrentUser(state, newValue) {
        state.currentUser = newValue
    },
    setUserData(state, userData) {
        state.currentUser = userData.user;
        usePermissions.setPermissions(userData.user.permissions);
    },
    clearUserData(state) {
        state.currentUser = null;
        usePermissions.clearPermissions();
    }
}

export const getters = {
    loggedIn(state) {
        return !!state.currentUser
    }
}

export const actions = {
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        dispatch('validate')
    },

    setCurrentUser({dispatch}, token) {
        localStorage.setItem('token', token)
        dispatch('initialize')
    },

    initialize({commit}) {
        const token = localStorage.getItem('token')

        if (!token) {
            return this.dispatch('reset')
        }

        http.get('me', {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
            })
            .then(response => {
                localStorage.setItem('permissions', JSON.stringify(response.data.permissions))
                commit('setCurrentUser', response.data);
                Router.push('/');
            })
            .catch(error => {
                console.error(error);
                localStorage.removeItem('token');
                Router.push('/login');
                notifyError('Você precisa se autenticar');
            });
    },

    refresh({commit}) {
        const token = localStorage.getItem('token')

        if (!token) {
            return this.dispatch('reset')
        }

        http.get('me', {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
            })
            .then(response => {
                localStorage.setItem('permissions', JSON.stringify(response.data.permissions))
                commit('setCurrentUser', response.data);
            })
            .catch(error => {
                console.error(error);
                localStorage.removeItem('token');
                Router.push('/login');
                notifyError(error.response);
            });
    },

    logout({commit}) {
        http
            .post('logout')
            .then(() => {
                localStorage.removeItem('token');
                commit('setCurrentUser', null);
            })
            .catch(error => {
                console.error(error)
            });
    },
}
